import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { useDispatch, useSelect } from '@wordpress/data';
import type { ValidationErrors, OfferData } from '../types/quote';
import { VENDOR_QUOTES_STORE } from "../constants";

export const useQuoteActions = (quoteId: number) => {
    const [ validationErrors, setValidationErrors ] = useState<ValidationErrors>({
        offerPrices: {},
        quantities: {},
        shippingCost: false
    });

    const { quote, isLoading } = useSelect((select) => ({
        quote: quoteId ? select( VENDOR_QUOTES_STORE ).getQuote( quoteId ) : [],
        isLoading: select( VENDOR_QUOTES_STORE ).getLoading()
    }));

    const dispatch = useDispatch( VENDOR_QUOTES_STORE );

    const handleApprove = (data: OfferData) => dispatch.approveQuote(quoteId, data);
    const handleUpdate = (data: OfferData) => dispatch.updateQuote(quoteId, data);
    const handleReject = () => dispatch.rejectQuote( quoteId );
    const handleReopen = () => dispatch.reopenQuote( quoteId );
    const handleConvert = () => dispatch.convertQuote( quoteId );

    return {
        handleApprove,
        handleUpdate,
        handleReject,
        handleReopen,
        handleConvert,
        isLoading,
        validationErrors,
        quote
    };
};
